export default {
      id: "live-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#live",
      toString: function () {
        return this.url;
      }
    }